module.exports = __webpack_public_path__ + "img/logo-estre.jpg";